// B1.4: tasks domain methods (move-only from client.ts).
import { ApiClientCore, buildQueryString } from './http/core';

export class TasksApi extends ApiClientCore {
  // ─── Tasks ──────────────────────────────────────────────────────────────────
  async getTasks(params: Record<string, any> = {}): Promise<any> {
    return this.get(`/api/v1/tasks${buildQueryString(params)}`);
  }
  async getTask(id: number): Promise<any> {
    return this.get(`/api/v1/tasks/${id}`);
  }
  async getTasksReport(): Promise<any> {
    return this.get('/api/v1/tasks/report');
  }
  async createTask(data: any): Promise<any> {
    return this.post('/api/v1/tasks', data);
  }
  async createTasksBulk(data: any): Promise<any> {
    return this.post('/api/v1/tasks/bulk', data);
  }
  async updateTask(id: number, data: any): Promise<any> {
    return this.put(`/api/v1/tasks/${id}`, data);
  }
  async updateTaskStatus(id: number, newStatus: string): Promise<any> {
    return this.put(`/api/v1/tasks/${id}/status`, { status: newStatus });
  }
  async assignTask(id: number, assignedToUserId: number): Promise<any> {
    return this.put(`/api/v1/tasks/${id}/assign`, { assigned_to_user_id: assignedToUserId });
  }
  async completeTask(id: number, data?: { completion_notes?: string; completion_photo_id?: number | null }): Promise<any> {
    return this.put(`/api/v1/tasks/${id}/complete`, data);
  }
  async takeTask(id: number): Promise<any> {
    return this.put(`/api/v1/tasks/${id}/take`, {});
  }
  async cancelTask(id: number, data: { cancellation_comment: string }): Promise<any> {
    return this.put(`/api/v1/tasks/${id}/cancel`, data);
  }
  async deleteTask(id: number): Promise<any> {
    return this.delete(`/api/v1/tasks/${id}`);
  }

  /** TIW F3/F6: unified entity_attachments */
  async addTaskAttachment(
    taskId: number,
    data: { file_id: number; role: 'brief' | 'result'; media_type?: 'photo' | 'voice' | 'video' }
  ): Promise<any> {
    return this.post(`/api/v1/tasks/${taskId}/attachments`, data);
  }
}
